const Color = {
  Stroke: "#094067",
  button: "#3da9fc",
  backgroundColor: "#edf1f7",
  buttonText: "#fffffe",
  paragraph: "#000",
  secondary: "#90b4ce",
  error: "#ef4565",
  stroke: "#094067",
  navColor: "#2f3e46",
  navParagraph: "#fff",
  boxShadow: "0px 10px 22px -3px rgba(0,0,0,0.4)",
  cardBoxShadow: "8px 8px 10px  rgba(0,0,0,0.4)",
  cardBackgroundColor: "#fff",
  cardHead: "#354f52",
  cardBody: "#52796f",
  loginBackground: "linear-gradient(315deg, #82ff89 0%, #c9d9ff 74%)",
  backgroundLotEmpty: "#198754",
  backgroundLotFull: "#dc3545",
};
export default Color;
